/*******************************************************************************
 * Project：
 * Summary:
 *　　 DateOfBirthComponent
 * Remarks:
 *     date of birth common component
 * History：
 *      NghiaNX            2021/05/26    Create
 *      NghiaNX            2021/09/16    Add err key
 *                                       0: empty; 1: Age > 200 ; 2: Age < 0; 3: en format; 4: ja format; 5: ja not exist year
 ******************************************************************************/
import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges, DoCheck } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Utility } from '../../utility/utility';
import { ElementRef } from '@angular/core';
// tslint:disable-next-line:no-conflicting-lifecycle
@Component({
  selector: 'app-date-of-birth',
  templateUrl: './date-of-birth.component.html',
  styleUrls: ['./date-of-birth.component.scss']
})
export class DateOfBirthComponent implements OnChanges, DoCheck {
  selectedYear = this.translate.instant('STR_SHOWA');
  lstYear: any[];
  labelYear: string;
  fYear = 0;
  tYear = 0;
  formMaxLength: number;
  dateOfBirth = '';
  crossRegex = /[\/]/g;
  regHaftWidth = /^[0-9]*$/;
  txtOutDoB: string;
  txtCurrYear: string;
  showDropDown = false;
  disableBtn = false;
  itemSlted: any;
  ageTxt = '';
  placeHolder = 'YY/MM/DD';
  DoBDay: Date;
  @Input() flag = '';
  @Input() txtDate = '';
  @Input() setReadonly = false;
  @Input() ageCalculate = '';
  @Output() eventFocusOut = new EventEmitter<any>();
  constructor(public translate: TranslateService, public util: Utility, private elem: ElementRef) {
    this.lstYear = this.util.getLstYear();
    this.formMaxLength = 8;
  }
  ngDoCheck(): void {
    if (this.lstYear?.length > 0 && this.util.lstYear?.length > 0) {
      if (this.lstYear[0].value !== this.util.lstYear[0].value) {
        for (const [idx, value] of this.lstYear.entries()) {
          this.lstYear[idx].value = this.util.lstYear[idx].value;
          if (this.lstYear[idx].active) {
            this.selectedYear = this.translate.instant(this.util.lstYear[idx].value);
          }
        }
      }
    }
  }
  ngOnChanges(changes: SimpleChanges) {
    // changes.prop contains the old and the new value...
    if (!this.util.isNullOrEmpty(changes) && !this.util.isNullOrEmpty(changes.txtDate)) {
      if (!this.util.isNullOrEmpty(changes.txtDate.currentValue) && !this.util.isNullOrEmpty(changes.txtDate.currentValue.trim())
        && (changes.txtDate.currentValue !== changes.txtDate.previousValue) && this.txtOutDoB !== changes.txtDate.currentValue) {
        this.selectedYear = this.getJaYear(changes.txtDate.currentValue);
        this.changeYear();
        this.loadJaDOB(changes.txtDate.currentValue);
        this.loadLabelYear();
        this.DoBDay = this.util.stringToDate(changes.txtDate.currentValue);
      } else if (this.util.isNullOrEmpty(changes.txtDate.currentValue)) {
        this.resetDoB();
        this.txtCurrYear = this.selectedYear;
        this.changeYear();
      }
      this.activeOption();
    } else if (!this.util.isNullOrEmpty(changes) && !this.util.isNullOrEmpty(changes.ageCalculate)
      && changes.ageCalculate.currentValue !== changes.ageCalculate.previousValue) {
      const formDate = this.util.stringToDate(this.txtOutDoB);
      this.ageTxt = this.util.calculateAge(formDate, changes.ageCalculate.currentValue);
    }
  }
  // tslint:disable-next-line: use-lifecycle-interface
  ngOnInit(): void {
  }
  activeOption() {
    for (const i of this.lstYear) {
      if (!this.util.isNullOrEmpty(this.selectedYear) && this.selectedYear === i.value) {
        i.active = true;
      } else {
        i.active = false;
      }
    }
  }
  onFocusIn() {
    this.dateOfBirth = this.dateOfBirth.replace(this.crossRegex, '');
    switch (this.selectedYear) {
      case this.translate.instant('STR_CHRISTAN_ERA'):
        this.formMaxLength = 8;
        break;
      default:
        this.formMaxLength = 6;
        break;
    }
  }
  FocusOutDate(pItem: Date, pIsStartDate) {
    console.log('DoB: ' + pItem);
    this.DoBDay = pItem;
    this.onFocusOut();
  }
  onFocusOut() {
    const resObj = {
      errCode: '',
      DateValue: ''
    };
    if (this.util.checkJPContry()) {
      this.ageTxt = '';
      this.txtOutDoB = '';
      let strHaftWidth = '';
      for (let i = 0; i < this.dateOfBirth.length; i++) {
        const char = this.dateOfBirth.charAt(i);
        const reg = new RegExp(this.regHaftWidth);
        if (reg.test(char)) {
          strHaftWidth += char;
        }
      }
      this.dateOfBirth = strHaftWidth;
      if (this.util.isNullOrEmpty(this.dateOfBirth)) {
        this.resetDoB();
      } else {
        switch (this.selectedYear) {
          case this.translate.instant('STR_CHRISTAN_ERA'):
            this.formMaxLength = 10;
            if (this.dateOfBirth.length > 4 && this.dateOfBirth.length < 7) {
              const y = this.dateOfBirth.substring(0, 4);
              const m = this.dateOfBirth.substring(4, 6);
              this.dateOfBirth = y + '/' + m;
            } else if (this.dateOfBirth.length >= 7) {
              const y = this.dateOfBirth.substring(0, 4);
              const m = this.dateOfBirth.substring(4, 6);
              const d = this.dateOfBirth.substring(6);
              this.dateOfBirth = y + '/' + m + '/' + d;
            }
            break;
          default:
            this.formMaxLength = 8;
            switch (this.dateOfBirth.length) {
              case 1:
              case 2:
              case 3:
                break;
              default:
                if (this.dateOfBirth.length < 5) {
                  const y = this.dateOfBirth.substring(0, 2);
                  const m = this.dateOfBirth.substring(2, 4);
                  this.dateOfBirth = y + '/' + m;
                } else {
                  const y = this.dateOfBirth.substring(0, 2);
                  const m = this.dateOfBirth.substring(2, 4);
                  const d = this.dateOfBirth.substring(4);
                  this.dateOfBirth = y + '/' + m + '/' + d;
                }
                break;
            }
            break;
        }
        this.loadLabelYear();
      }
      const keyErr = this.checkErrDateOfBirth();
      if (!this.util.isNullOrEmpty(keyErr)) {
        this.labelYear = '';
      }
      resObj.errCode = keyErr;
      resObj.DateValue = this.txtOutDoB;
    } else {
      resObj.DateValue = this.util.dateToString(this.DoBDay);
    }
    this.eventFocusOut.emit(resObj);
  }
  checkErrDateOfBirth() {
    let errCode = '';
    if (this.dateOfBirth === '') {
      errCode = '0';
    } else if (this.dateOfBirth !== '' && this.txtOutDoB === '') {
      switch (this.selectedYear) {
        case this.translate.instant('STR_CHRISTAN_ERA'):
          errCode = '3';
          break;
        default:
          errCode = '4';
          break;
      }
    } else if (this.dateOfBirth !== '' && this.txtOutDoB !== '') {
      switch (this.selectedYear) {
        case this.translate.instant('STR_CHRISTAN_ERA'):
          if (this.dateOfBirth.length < 10) {
            errCode = '4';
          }
          break;
        default:
          if (this.dateOfBirth.length < 8) {
            errCode = '5';
          }
          break;
      }
      if (errCode === '') {
        if (Number(this.ageTxt) > 200) {
          errCode = '1';
        } else if (Number(this.ageTxt) < 0) {
          errCode = '2';
        }
      }
    }
    return errCode;
  }
  resetDoB() {
    this.dateOfBirth = '';
    this.txtOutDoB = '';
    this.labelYear = '';
    this.ageTxt = '';
  }
  changeYear() {
    this.resetDoB();
    this.formMaxLength = 6;
    const curDate = new Date();
    switch (this.selectedYear) {
      case this.translate.instant('STR_TAISHO'):
        this.fYear = 1912; this.tYear = 1925;
        break;
      case this.translate.instant('STR_SHOWA'):
        this.fYear = 1926; this.tYear = 1988;
        break;
      case this.translate.instant('STR_HEISEI'):
        this.fYear = 1990; this.tYear = 2018;
        break;
      case this.translate.instant('STR_REIWA'):
        this.fYear = 2019; this.tYear = curDate.getFullYear();
        break;
      default:
        this.formMaxLength = 8;
        break;
    }
    this.txtCurrYear = this.selectedYear;
  }
  /**
   * Load label year
   * IF date not valid => Output data is blank
   */
  loadLabelYear() {
    const arrDob = this.dateOfBirth.split('/');
    if (arrDob.length < 3) { return; }
    const year = !this.util.isNullOrEmpty(arrDob[0]) ? (Number(arrDob[0])) : null;
    const month = !this.util.isNullOrEmpty(arrDob[1]) ? (Number(arrDob[1])) : null;
    const day = !this.util.isNullOrEmpty(arrDob[2]) ? (Number(arrDob[2])) : null;
    switch (this.selectedYear) {
      case this.translate.instant('STR_CHRISTAN_ERA'):
        const enValidDoB = this.isValidDoB(day, month, year);
        if (enValidDoB) {
          this.labelYear = this.setLabelYear(year.toString());
          this.txtOutDoB = this.outStrDoB(year, month, day, '');
        } else {
          this.labelYear = '';
          this.txtOutDoB = '';
        }
        break;
      default:
        const isJaYear = arrDob[0].length > 2 ? false : true;
        const enY = isJaYear ? year + this.fYear - 1 : year;
        const jaYear = isJaYear ? year : year - this.fYear + 1;
        const jaValidY = jaYear <= this.tYear - this.fYear + 1;
        const jaValidDoB = this.isValidDoB(day, month, enY);
        if (jaValidY && jaValidDoB) {
          this.labelYear = enY.toString() + '年';
          this.txtOutDoB = this.outStrDoB(enY, month, day, '');
        } else {
          this.labelYear = enY.toString() + '年';
          this.txtOutDoB = '';
        }
        break;
    }
    if (this.txtOutDoB !== '') {
      const formDate = this.util.stringToDate(this.txtOutDoB);
      this.ageTxt = this.util.calculateAge(formDate, this.ageCalculate);
    }
  }
  setLabelYear(year: string) {
    let lbYear = '';
    let jaYear: number;
    lbYear = this.getJaYear(year);
    switch (lbYear) {
      case this.translate.instant('STR_TAISHO'):
        jaYear = Number(year) - 1912 + 1;
        break;
      case this.translate.instant('STR_SHOWA'):
        jaYear = Number(year) - 1926 + 1;
        break;
      case this.translate.instant('STR_HEISEI'):
        jaYear = Number(year) - 1990 + 1;
        break;
      case this.translate.instant('STR_REIWA'):
        jaYear = Number(year) - 2019 + 1;
        break;
      default:
        jaYear = null;
        break;
    }
    if (lbYear === '') {
      return '';
    }
    const strJaYear = jaYear < 10 ? '0' + jaYear : jaYear.toString();
    return lbYear + strJaYear + '年';
  }
  loadJaDOB(value: string) {
    const dobYear = Number(value.substring(0, 4));
    const dobMonth = value.substring(4, 6);
    const dobDay = value.substring(6);
    switch (this.selectedYear) {
      case this.translate.instant('STR_CHRISTAN_ERA'):
        this.formMaxLength = 10;
        this.dateOfBirth = dobYear + '/' + dobMonth + '/' + dobDay;
        break;
      default:
        this.formMaxLength = 8;
        const jaY = (dobYear - this.fYear + 1) < 10 ? '0' + (dobYear - this.fYear + 1) : (dobYear - this.fYear + 1);
        this.dateOfBirth = jaY + '/' + dobMonth + '/' + dobDay;
        break;
    }
  }
  getJaYear(value: string) {
    let strYear = '';
    const dobYear = Number(value.substring(0, 4));
    if (dobYear >= 1912 && dobYear <= 1925) {
      strYear = this.translate.instant('STR_TAISHO');
    } else if (dobYear >= 1926 && dobYear <= 1988) {
      strYear = this.translate.instant('STR_SHOWA');
    } else if (dobYear >= 1989 && dobYear <= 2018) {
      strYear = this.translate.instant('STR_HEISEI');
    } else if (dobYear >= 2019) {
      strYear = this.translate.instant('STR_REIWA');
    }
    return strYear;
  }
  daysInMonth(m: number, y: number) {
    switch (m) {
      case 2:
        return (y % 4 === 0 && y % 100) || y % 400 === 0 ? 29 : 28;
      case 9: case 4: case 6: case 11:
        return 30;
      default:
        return 31;
    }
  }
  isValidDoB(d: number, m: number, y: number) {
    return m >= 1 && m <= 12 && d > 0 && d <= this.daysInMonth(m, y);
  }
  outStrDoB(y: number, m: number, d: number, format: string) {
    const strY = y.toString();
    const strM = m > 9 ? m.toString() : '0' + m.toString();
    const strD = d > 9 ? d.toString() : '0' + d.toString();
    return strY + format + strM + format + strD;
  }
  selected(it: any) {
    const oldValue = this.dateOfBirth;
    const oldJaYear = this.labelYear?.substring(0, 2);
    this.lstYear.map(m => m.active = false);
    it.active = true;
    this.selectedYear = it.value;
    switch (it.value) {
      case this.translate.instant('STR_CHRISTAN_ERA'):
        this.placeHolder = 'YYYY/MM/DD';
        break;
      default:
        this.placeHolder = 'YY/MM/DD';
        break;
    }
    this.changeYear();
    this.showDropDown = false;
    if ((oldValue.length === 8 && this.selectedYear === this.translate.instant('STR_CHRISTAN_ERA'))
      || (oldValue.length === 10 && this.selectedYear !== this.translate.instant('STR_CHRISTAN_ERA') && oldJaYear === this.selectedYear)) {
      this.changeRegion(oldValue);
      this.loadLabelYear();
    }
  }
  outSelectValue() {
    this.showDropDown = false;
  }
  changeRegion(value: string) {
    const arrDob = value.split('/');
    const year = Number(arrDob[0]);
    const month = Number(arrDob[1]);
    const day = Number(arrDob[2]);
    switch (this.selectedYear) {
      case this.translate.instant('STR_CHRISTAN_ERA'):
        const isJaYear = arrDob[0].length > 2 ? false : true;
        const enY = isJaYear ? year + this.fYear - 1 : year;
        const jaYear = isJaYear ? year : year - this.fYear + 1;
        const jaValidY = jaYear <= this.tYear - this.fYear + 1;
        const jaValidDoB = this.isValidDoB(day, month, enY);
        if (jaValidY && jaValidDoB) {
          this.dateOfBirth = this.outStrDoB(enY, month, day, '/');
        }
        break;
      default:
        const enValidDoB = this.isValidDoB(day, month, year);
        if (enValidDoB) {
          this.dateOfBirth = this.outStrDoB(year, month, day, '/');
        }
        break;
    }
  }
}
